module.exports = __webpack_public_path__ + "img/t2-2.696bdc60.png";